import { matchIsValidTel } from 'mui-tel-input';

const isEmail = email => email.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g);

const isPhoneNumber = phoneNumber => matchIsValidTel(phoneNumber);

const containsCapitalSmallLetter = password => password.match(/^(?=.*[a-z])(?=.*[A-Z]).+$/g);

const containsSpecialCharacter = password => password.match(/\W/g);

const containsNumber = password => password.match(/[0-9]/g);

const passwordLengthRestriction = password => password.length >= 8;

export const ValidationHelper = {
  isEmail,
  isPhoneNumber,
  containsCapitalSmallLetter,
  containsSpecialCharacter,
  containsNumber,
  passwordLengthRestriction,
};
